/**
 * Сайдбар с вкладками, как в JS_React-Node_Site_AdminPanel.
 */

import { DEV_TABS } from "../../config/dev";

function DevLayout({ tab, onTab, onLogout, children }) {
    return (
        <div className="dev-layout">
            <aside className="dev-layout__sidebar">
                <div className="dev-layout__brand">Developer</div>
                <nav className="dev-layout__nav">
                    {DEV_TABS.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            className={`dev-layout__tab${tab === item.id ? " dev-layout__tab_active" : ""}`}
                            onClick={() => onTab(item.id)}
                        >
                            {item.title}
                            <span>{item.hint}</span>
                        </button>
                    ))}
                </nav>
                <div className="dev-layout__footer">
                    <div className="dev-layout__user">dev · owner</div>
                    <button type="button" className="dev-layout__logout" onClick={onLogout}>
                        Logout
                    </button>
                </div>
            </aside>
            <main className="dev-layout__content">{children}</main>
        </div>
    );
}

export default DevLayout;
// components/DevAdmin/DevLayout.js
